<template>
  <ContentWrap>
    <el-alert
      type="info"
      :closable="false"
      show-icon
      title="所内收费台账（应收/收款），不等于平台分账 W6。先建应收草稿 → 开账 → 登记收款。"
      class="mb-12px"
    />
    <el-tabs v-model="tab" @tab-change="onTabChange">
      <el-tab-pane label="应收" name="ar" />
      <el-tab-pane label="收款" name="receipt" />
    </el-tabs>

    <template v-if="tab === 'ar'">
      <el-form :inline="true" class="mb-12px" @submit.prevent>
        <el-form-item label="案件ID">
          <el-input-number v-model="arQuery.caseId" :min="1" controls-position="right" class="!w-120px" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="arQuery.status" clearable class="!w-120px">
            <el-option label="草稿" value="DRAFT" />
            <el-option label="未收" value="OPEN" />
            <el-option label="部分已收" value="PARTIAL" />
            <el-option label="已收清" value="CLEARED" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadAr">搜索</el-button>
          <el-button type="success" @click="openArCreate">新建应收</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="arLoading" :data="arList" border>
        <el-table-column prop="id" label="编号" width="70" />
        <el-table-column prop="firmCaseNo" label="案号" min-width="120" />
        <el-table-column prop="title" label="标题" min-width="120" show-overflow-tooltip />
        <el-table-column prop="feeType" label="类型" width="100" />
        <el-table-column prop="amount" label="应收" width="100" />
        <el-table-column prop="receivedAmount" label="已收" width="100" />
        <el-table-column prop="outstandingAmount" label="未收" width="100" />
        <el-table-column prop="status" label="状态" width="100" />
        <el-table-column label="操作" width="160" fixed="right">
          <template #default="{ row }">
            <el-button v-if="row.status === 'DRAFT'" link type="primary" @click="doOpen(row)">开账</el-button>
            <el-button
              v-if="row.status === 'OPEN' || row.status === 'PARTIAL'"
              link
              type="success"
              @click="openReceipt(row)"
            >
              收款
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        v-model:page="arQuery.pageNo"
        v-model:limit="arQuery.pageSize"
        :total="arTotal"
        @pagination="loadAr"
      />
    </template>

    <template v-else>
      <el-form :inline="true" class="mb-12px" @submit.prevent>
        <el-form-item label="案件ID">
          <el-input-number v-model="rcQuery.caseId" :min="1" controls-position="right" class="!w-120px" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadRc">搜索</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="rcLoading" :data="rcList" border>
        <el-table-column prop="id" label="编号" width="70" />
        <el-table-column prop="caseTitle" label="案件" min-width="140" show-overflow-tooltip />
        <el-table-column prop="receivableId" label="应收ID" width="90" />
        <el-table-column prop="amount" label="金额" width="100" />
        <el-table-column prop="payTime" label="收款时间" width="170" />
        <el-table-column prop="payMethod" label="方式" width="90" />
        <el-table-column prop="status" label="状态" width="90" />
      </el-table>
      <Pagination
        v-model:page="rcQuery.pageNo"
        v-model:limit="rcQuery.pageSize"
        :total="rcTotal"
        @pagination="loadRc"
      />
    </template>

    <Dialog v-model="arVisible" title="新建应收" width="480px">
      <el-form ref="arFormRef" :model="arForm" :rules="arRules" label-width="90px">
        <el-form-item label="案件" prop="caseId">
          <el-select v-model="arForm.caseId" filterable class="!w-100%">
            <el-option
              v-for="m in matterOptions"
              :key="m.id"
              :label="`${m.firmCaseNo || m.id} · ${m.title}`"
              :value="m.id!"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="费用类型" prop="feeType">
          <el-select v-model="arForm.feeType" class="!w-100%">
            <el-option label="首期/定金" value="DEPOSIT" />
            <el-option label="中期" value="MID" />
            <el-option label="尾款" value="FINAL" />
            <el-option label="其他" value="OTHER" />
          </el-select>
        </el-form-item>
        <el-form-item label="金额" prop="amount">
          <el-input-number v-model="arForm.amount" :min="0.01" :precision="2" :step="100" class="!w-100%" />
        </el-form-item>
        <el-form-item label="标题">
          <el-input v-model="arForm.title" />
        </el-form-item>
        <el-form-item label="到期日">
          <el-date-picker v-model="arForm.dueDate" type="date" value-format="YYYY-MM-DD" class="!w-100%" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="arVisible = false">取消</el-button>
        <el-button type="primary" :loading="arSaving" @click="submitAr">保存草稿</el-button>
      </template>
    </Dialog>

    <Dialog v-model="rcVisible" title="登记收款" width="480px">
      <el-form ref="rcFormRef" :model="rcForm" :rules="rcRules" label-width="90px">
        <el-form-item label="应收">
          <span>#{{ rcForm.receivableId }} · ¥{{ rcForm.amount }}</span>
        </el-form-item>
        <el-form-item label="金额" prop="amount">
          <el-input-number v-model="rcForm.amount" :min="0.01" :precision="2" class="!w-100%" />
        </el-form-item>
        <el-form-item label="时间" prop="payTime">
          <el-date-picker
            v-model="rcForm.payTime"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
            class="!w-100%"
          />
        </el-form-item>
        <el-form-item label="方式">
          <el-select v-model="rcForm.payMethod" clearable class="!w-100%">
            <el-option label="现金" value="CASH" />
            <el-option label="银行转账" value="BANK" />
            <el-option label="微信" value="WX" />
            <el-option label="支付宝" value="ALIPAY" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="rcVisible = false">取消</el-button>
        <el-button type="primary" :loading="rcSaving" @click="submitRc">确认收款</el-button>
      </template>
    </Dialog>
  </ContentWrap>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue'
import type { FormInstance, FormRules } from 'element-plus'
import {
  FirmPracticeApi,
  type PracticeMatterVO,
  type PracticeReceiptVO,
  type PracticeReceivableVO
} from '@/api/firm/practice'

defineOptions({ name: 'FirmPracticeFee' })

const message = useMessage()
const tab = ref<'ar' | 'receipt'>('ar')
const matterOptions = ref<PracticeMatterVO[]>([])

const arLoading = ref(false)
const arList = ref<PracticeReceivableVO[]>([])
const arTotal = ref(0)
const arQuery = reactive({
  pageNo: 1,
  pageSize: 10,
  caseId: undefined as number | undefined,
  status: undefined as string | undefined
})

const rcLoading = ref(false)
const rcList = ref<PracticeReceiptVO[]>([])
const rcTotal = ref(0)
const rcQuery = reactive({
  pageNo: 1,
  pageSize: 10,
  caseId: undefined as number | undefined
})

const arVisible = ref(false)
const arSaving = ref(false)
const arFormRef = ref<FormInstance>()
const arForm = reactive({
  caseId: undefined as number | undefined,
  feeType: 'DEPOSIT',
  amount: 0,
  title: '',
  dueDate: undefined as string | undefined
})
const arRules: FormRules = {
  caseId: [{ required: true, message: '请选择案件', trigger: 'change' }],
  feeType: [{ required: true, message: '请选择类型', trigger: 'change' }],
  amount: [{ required: true, message: '请输入金额', trigger: 'blur' }]
}

const rcVisible = ref(false)
const rcSaving = ref(false)
const rcFormRef = ref<FormInstance>()
const rcForm = reactive({
  caseId: 0,
  receivableId: 0,
  amount: 0,
  payTime: '',
  payMethod: 'BANK'
})
const rcRules: FormRules = {
  amount: [{ required: true, message: '请输入金额', trigger: 'blur' }],
  payTime: [{ required: true, message: '请选择时间', trigger: 'change' }]
}

const loadAr = async () => {
  arLoading.value = true
  try {
    const data = await FirmPracticeApi.receivablePage(arQuery)
    arList.value = data?.list || []
    arTotal.value = data?.total || 0
  } finally {
    arLoading.value = false
  }
}

const loadRc = async () => {
  rcLoading.value = true
  try {
    const data = await FirmPracticeApi.receiptPage(rcQuery)
    rcList.value = data?.list || []
    rcTotal.value = data?.total || 0
  } finally {
    rcLoading.value = false
  }
}

const onTabChange = () => {
  if (tab.value === 'ar') loadAr()
  else loadRc()
}

const openArCreate = async () => {
  arForm.caseId = undefined
  arForm.feeType = 'DEPOSIT'
  arForm.amount = 0
  arForm.title = ''
  arForm.dueDate = undefined
  arVisible.value = true
  const matters = await FirmPracticeApi.matterPage({ pageNo: 1, pageSize: 100 })
  matterOptions.value = matters?.list || []
}

const submitAr = async () => {
  await arFormRef.value?.validate()
  if (!arForm.caseId || !arForm.amount) return
  arSaving.value = true
  try {
    await FirmPracticeApi.receivableCreate({
      caseId: arForm.caseId,
      feeType: arForm.feeType,
      amount: arForm.amount,
      title: arForm.title || undefined,
      dueDate: arForm.dueDate
    })
    message.success('已创建应收草稿')
    arVisible.value = false
    await loadAr()
  } finally {
    arSaving.value = false
  }
}

const doOpen = async (row: PracticeReceivableVO) => {
  if (!row.id) return
  await FirmPracticeApi.receivableOpen(row.id)
  message.success('已开账')
  await loadAr()
}

const openReceipt = (row: PracticeReceivableVO) => {
  rcForm.caseId = row.caseId
  rcForm.receivableId = row.id!
  rcForm.amount = Number(row.outstandingAmount ?? row.amount) || 0
  rcForm.payTime = ''
  rcForm.payMethod = 'BANK'
  rcVisible.value = true
}

const submitRc = async () => {
  await rcFormRef.value?.validate()
  rcSaving.value = true
  try {
    await FirmPracticeApi.receiptCreate({
      caseId: rcForm.caseId,
      receivableId: rcForm.receivableId,
      amount: rcForm.amount,
      payTime: rcForm.payTime,
      payMethod: rcForm.payMethod || undefined
    })
    message.success('已登记收款')
    rcVisible.value = false
    tab.value = 'receipt'
    await loadRc()
  } finally {
    rcSaving.value = false
  }
}

onMounted(loadAr)
</script>
